var root = require('./_root');

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;



//////////////////
// WEBPACK FOOTER
// ./~/react-sortable-hoc/~/lodash/_coreJsData.js
// module id = 3406
// module chunks = 4